import { Navigate, useRoutes } from "react-router-dom";

import { protectedRoutes } from "@/routes/protected";
import { publicRoutes } from "@/routes/public";

import { NotFound } from "@/features/_misc/NotFound";

export const AppRoutes = () => {
  const commonRoutes = [
    { path: "/", element: <Navigate to="/app" /> },
    { path: "/login", element: <Navigate to="/auth/login" /> },
    { path: "/sign-up", element: <Navigate to="/auth/sign-up" /> },
    { path: "*", element: <NotFound /> },
  ];
  const routes = [...protectedRoutes, ...publicRoutes];
  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
